import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export const WcLocalizationProvider = LocalizationProvider;
